import { Component, inject } from '@angular/core';
import { AuthenticationService } from '@core/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
})
export class HeaderComponent {
private authService = inject(AuthenticationService);

  login(){
    this.authService.initiateUL();
  }

  signup(){
    this.authService.initiateULSignup();
  }
}
